import React from 'react'
import { UserDto, UserRole } from '../../services/api/sharedTypes/User'
import { MenuItem, Select, Table, TableBody, TableContainer, TableRow, Typography } from '@mui/material'
import EnhancedTableHead from '../../components/table/EnhancedTableHead'
import { HeadCell, Order, getComparator, stableSort } from '../../utils/tableFunctions'
import CustomTableCell from '../../components/common/CustomTableCell'
import TableButtonDelete from '../../components/table/TableButtonDelete'
import LoadingTableRow from '../../components/table/LoadingTableRow'

interface UserTableProps {
    userList: UserDto[]
    onChange: (id: string, role: UserRole, index: number) => void
    onDelete: (id: string, index: number) => void
    loadingColumn: number
}

const headCells: readonly HeadCell[] = [
    {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: 'Jméno/e-mail',
    },
    {
        id: 'role',
        numeric: false,
        disablePadding: false,
        label: 'Role',
        centered: true,
    },
    {
        id: 'buttons',
        numeric: false,
        disablePadding: false,
        label: '',
    }
]

const UserTable: React.FC<UserTableProps> = ({ userList, onChange, onDelete, loadingColumn }: UserTableProps) => {
    const [order, setOrder] = React.useState<Order>('desc')
    const [orderBy, setOrderBy] = React.useState<string>('startsAt')

    const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }

    return (
        <>
            <Typography variant='body2' mb={3}>
                {userList.length} záznamů
            </Typography>
            <TableContainer>
                <Table>
                    <EnhancedTableHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={userList.length}
                        headCells={headCells}
                    />
                    <TableBody>
                        {stableSort(
                            userList.map((row) => {
                                return {
                                    ...row,
                                    createdAt: new Date(row.createdAt).toLocaleDateString(),
                                    lastModifiedAt: new Date(row.lastModifiedAt).toLocaleDateString(),
                                }
                            }),
                            getComparator(order, orderBy)
                        ).map((row, index: number) => {
                            return (
                                loadingColumn === index ? <LoadingTableRow key={index} numberOfRows={headCells.length} /> : (
                                    <TableRow
                                        tabIndex={-1}
                                        key={index}
                                        style={{
                                            height: '42px',
                                        }}
                                    >
                                        <CustomTableCell isText>
                                            {row.username}
                                        </CustomTableCell>
                                        <CustomTableCell isText center>
                                            <Select
                                                value={row.role}
                                                style={{ maxHeight: 36, minWidth: 150 }}
                                                onChange={(e) => onChange(row.id, e.target.value as UserRole, index)}
                                            >
                                                <MenuItem value={UserRole.Admin}>Admin</MenuItem>
                                                <MenuItem value={UserRole.User}>Uživatel</MenuItem>
                                            </Select>
                                        </CustomTableCell>
                                        <CustomTableCell align='right'>
                                            <TableButtonDelete
                                                nameOfEntityInDialogMessage={row.username}
                                                onClick={() => onDelete(row.id, index)}
                                            />
                                        </CustomTableCell>
                                    </TableRow>
                                )
                            )
                        })}
                        {userList.length < loadingColumn && <LoadingTableRow numberOfRows={headCells.length} />}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default UserTable